import { employeeConstants } from 'utils/constants/employee-constants'
import _ from 'lodash'
import { bookingConstants, bookingStatus } from 'utils/constants/booking-constants'
import Description from 'components/atoms/Description'
import i18n from 'utils/i18n'
import ObjectTimeslot from 'utils/objects/timeslot'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { StyleSheet, View } from 'react-native'
import HelperString from 'utils/helper-string'
import EmployeeCard, { EmployeeCardModes, EmployeeCardShowConstants, EmployeeCardShowValues } from 'components/molecules/EmployeeCard'
import Button from "theme/Button";
import { colorList } from 'utils/colors'
import { ScannedInText } from 'components/atoms/EmployeeScan'
import React, { useState } from 'react'
import ObjectBooking from 'utils/objects/booking'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation, useRoute } from '@react-navigation/native'
import ModalScan from 'scenes/management/bookings/_components/ModalScan'
import ModalStatus from 'scenes/management/bookings/_components/ModalStatus'
import ModalRemove from 'scenes/management/bookings/_components/ModalRemove'
import { ThemedSizes } from 'styles/themed'
import DataItem from 'components/atoms/DataItem'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { EmployeeParkingScans } from 'components/atoms/EmployeeParkingScans'
import dayjs from 'dayjs'
import HelperDate, { dateFormat } from 'utils/helper-date'
import VStack from 'components/atoms/stack/VStack'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationManagementLicenseValidate from 'graphql/mutations/management/MutationManagementLicenseValidate'

const MODAL = {
	REMOVE: 'remove',
	SCAN: 'scan',
	STATUS: 'status'
}

const BookingsListItem = ({ section, item, reload, children }) => {
	
	const navigation = useNavigation();
	const route = useRoute();
	
	const [ modal, setModal ] = useState( null )
	const [ modalProps, setModalProps ] = useState( {} )
	const [ isValidating, setIsValidating ] = useState( false )
	
	// Employee
	const isInternal = _.get( item, 'kind', employeeConstants.KIND_INTERNAL ) === employeeConstants.KIND_INTERNAL;
	
	// Booking
	const bookingCount = _.size( item.bookings );
	const booking = _.first( item.bookings );
	const bookingReason = _.get( booking, 'reason', null );
	const scan = _.get( booking, 'employee_scan', {} );
	const parkingScans = _.get( booking, 'employee_parking_scans', {} );
	const buildingGuid = _.get( booking, ['building', 'guid'], null );
	const bookingCreatedAt = _.get( booking, 'created_at', null );
	const bookingIsManualValidation = booking?.status === bookingStatus.MANUAL_VALIDATION;
	
	const kind = _.get( route.params, 'kind', null );
	const isToday = HelperDate.fn.isToday( HelperDate.date( booking.booking_date, dateFormat.DATE ) )
	
	let statusIsInvited = false;
	_.forEach( item.bookings, o => {
		if( [ bookingStatus.INVITED ].includes( o.status ) ) {
			statusIsInvited = true;
			return true;
		}
	})
	
	//
	let contentTimeslotTime = null;
	if( bookingCount < section?.booking_count ) {
		contentTimeslotTime = (
			<Description>
				{ i18n.t('management:generic.timeslot.description_accepted_some', {
					timeslots: ObjectTimeslot.groupTimeslotTime( _.map( item.bookings, o => {
						return o.timeslot;
					} ) )
				})}
			</Description>
		);
	}
	
	let hasEditRightAcceptStatus = null;
	let hasEditRightScanIn = null;
	let hasEditRightCancel = null;
	
	let show = {
		[ EmployeeCardShowConstants.TEAM ]: EmployeeCardShowValues.YES,
		[ EmployeeCardShowConstants.TIMESLOT_KIND ]: EmployeeCardShowValues.YES,
	}
	
	switch( kind ) {
		case bookingConstants.BOOKING:
			hasEditRightAcceptStatus = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_WORKPLACES_ACCEPTED_STATUS );
			hasEditRightScanIn  = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_WORKPLACES_SCAN_IN );
			hasEditRightCancel = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_WORKPLACES_CANCEL );
			break;
		
		case bookingConstants.LUNCH:
			hasEditRightAcceptStatus = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_LUNCH_ACCEPTED_STATUS );
			hasEditRightScanIn  = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_LUNCH_SCAN_IN );
			hasEditRightCancel = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_LUNCH_CANCEL );
			break;
		
		case bookingConstants.MEETING_ROOM:
			hasEditRightAcceptStatus = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_MEETING_ROOMS_ACCEPTED_STATUS );
			hasEditRightScanIn  = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_MEETING_ROOMS_SCAN_IN );
			hasEditRightCancel = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_MEETING_ROOMS_CANCEL );
			break;
		
		case bookingConstants.TRANSPORT:
			hasEditRightAcceptStatus = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_PARKING_SPOTS_ACCEPTED_STATUS );
			hasEditRightScanIn  = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_PARKING_SPOTS_SCAN_IN );
			hasEditRightCancel = HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BOOKINGS_PARKING_SPOTS_CANCEL );
			
			show = {
				...show,
				[ EmployeeCardShowConstants.LICENSE_PLATE ]: EmployeeCardShowValues.YES
			}
			break;
	}
	
	const openEmployee =  ( employee ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_EMPLOYEES_EMPLOYEE_VIEW, {
			employeeGuid: employee.guid
		} );
	}
	
	const onShowModal = ( modalKind, modalProps ) => {
		setModal( modalKind )
		setModalProps( modalProps )
	}
	
	const onPressValidate = ({ bookings, validate }) => {
		// Get the license plate
		const licensePlateId = _.get( _.first( bookings ), ['license_plate_item', 'id'], null );
		
		new GraphqlBuilder()
			.addQuery( 'mutation_license_plate_validate', MutationManagementLicenseValidate, {
				license_plate_id: licensePlateId,
				employee_booking_guid: _.map( bookings, 'guid' ),
				validate: validate
			})
			.setOnStart( setIsValidating.bind( this, true ) )
			.setOnError( setIsValidating.bind( this, false ) )
			.setOnSuccess( result => {
				// Reload the data
				if( _.isFunction( reload ) ) {
					reload();
				}
				
				setIsValidating( false )
			})
			.execute()
	}
	
	const onHideModal = () => {
		setModal( null )
		setModalProps( {} )
	}
	
	return (
		<View
			style={ [
				styles.listItem,
				bookingKindStyles[ kind ]?.listItem
			]}>
			
			<View
				style={ styles.viewFlexDirectionRowWidth100 }>
				
				<EmployeeCard
					mode={ EmployeeCardModes.listItem }
					avatarSize={ ThemedSizes.S }
					avatarShowIconEro={ false }
					avatarShowIconConfidant={ false }
					showHeart={ false }
					show={ show }
					employee={ item }
					onPress={ isInternal ? () => {
						return openEmployee;
					} : null }>
					
					<DataItem
						content={ dayjs( bookingCreatedAt ).format( dateFormat.DATE_TIME ) }>
						
						{ i18n.t('management:generic.created_at') }
					</DataItem>
					
					{/* Scanned in text */}
					{ statusIsInvited && (
						<DataItem
							content={ i18n.t('management:generic.booking_status.invite_open') }>
							
							{ i18n.t('constants.status') }
						</DataItem>
					)}
					
					{/* Scan in text */}
					{ (!bookingIsManualValidation && !statusIsInvited) && (
						<>
							<ScannedInText
								item={ scan }
							/>
							
							{ contentTimeslotTime }
						</>
					)}
					
					{ kind === bookingConstants.TRANSPORT && (
						<EmployeeParkingScans items={ parkingScans } />
					)}
					
					{/* Booking reason */}
					{ bookingReason !== null && (
						<DataItem
							content={ bookingReason }>
							
							{ i18n.t('page.create.overview.form.reason.title') }
						</DataItem>
					)}
					
					{ children }
				</EmployeeCard>
				
				<View
					style={ styles.listItemButtonContainer }>
					
					{ bookingIsManualValidation && (
						<VStack>
							<Button
								appearance={ 'primary' }
								size={ "small" }
								isLoading={ isValidating }
								onPress={ onPressValidate.bind( this, { bookings: item.bookings, validate: true } ) }
								icon={ ( props ) => {
									return (
										<Icon
											{ ...props }
											icon={ IconSystemConstants.MORE }
											color={'white'}
										/>
									);
								}}>
								
								{ i18n.t('management:pages.bookings.view.bookings_validate.approve.button') }
							</Button>
							<Button
								appearance={ 'ghost' }
								size={ "small" }
								isLoading={ isValidating }
								onPress={ onPressValidate.bind( this, { bookings: item.bookings, validate: false } ) }
								icon={ ( props ) => {
									return (
										<Icon
											{...props}
											icon={ IconSystemConstants.PLUS }
											color={ colorList.PRIMARY.primary }
										/>
									);
								}}>
								
								{ i18n.t('management:pages.bookings.view.bookings_validate.disapprove.button') }
							</Button>
						</VStack>
					)}
					
					{ hasEditRightCancel && (
						<Button
							appearance={ 'ghost' }
							size={ "small" }
							onPress={ onShowModal.bind( this, MODAL.REMOVE, { bookings: item.bookings } ) }
							style={ styles.button }
							accessoryRight={ ( props ) => {
								return <Icon icon={IconSystemConstants.TRASH} {...props} />;
							}}>
						</Button>
					)}
					
					{/* Scan button */}
					{ (hasEditRightScanIn && !statusIsInvited && isToday && _.isEmpty( scan ) )  && (
						<Button
							appearance={ 'ghost' }
							size={ "small" }
							onPress={ onShowModal.bind( this, MODAL.SCAN, { employeeGuid: item.guid, buildingGuid: buildingGuid } ) }
							style={ styles.button }
							accessoryRight={ ( props ) => {
								return <Icon icon={IconSystemConstants.QRCODE} {...props} />;
							}}>
						</Button>
					)}
					
					{/* Status change button */}
					{ hasEditRightCancel && (
						<Button
							appearance={ 'ghost' }
							size={ "small" }
							onPress={ onShowModal.bind( this, MODAL.STATUS, { bookings: item.bookings, status: booking.status } ) }
							style={ styles.button }
							accessoryRight={ ( props ) => {
								return <Icon icon={IconSystemConstants.PERSON_CHECK} {...props} />;
							}}>
						</Button>
					)}
				</View>
			</View>
			
			{/* modals */}
			<ModalScan
				visible={ modal === MODAL.SCAN }
				onHide={ onHideModal }
				reload={ reload }
				{ ...modalProps }
			/>
			
			<ModalStatus
				visible={ modal === MODAL.STATUS }
				onHide={ onHideModal }
				reload={ reload }
				{ ...modalProps }
			/>
			
			<ModalRemove
				visible={ modal === MODAL.REMOVE }
				onHide={ onHideModal }
				reload={ reload }
				{ ...modalProps }
			/>
		</View>
	);
}

const styles = StyleSheet.create({
	viewFlexDirectionRowWidth100: {
		flexDirection: 'row',
		width: '100%',
		justifyContent: 'space-between',
	},
	listItem: {
		flex: 1,
		backgroundColor: colorList.WHITE.primary,
		paddingVertical: 8,
	},
	listItemButtonContainer: {
		width: 'auto',
		alignItems: 'flex-end',
		justifyContent: 'flex-start',
	},
	button: {
		minWidth: 'auto'
	}
})

const bookingKindStyles = {
	[ bookingConstants.BOOKING ]: StyleSheet.create({
		listItem: {
			borderLeftWidth: 5,
			borderLeftColor: ObjectBooking.getColor( { kind: bookingConstants.BOOKING } ).primary
		}
	}),
	[ bookingConstants.MEETING_ROOM ]: StyleSheet.create({
		listItem: {
			borderLeftWidth: 5,
			borderLeftColor: ObjectBooking.getColor( { kind: bookingConstants.MEETING_ROOM } ).primary
		}
	}),
	[ bookingConstants.LUNCH ]: StyleSheet.create({
		listItem: {
			borderLeftWidth: 5,
			borderLeftColor: ObjectBooking.getColor( { kind: bookingConstants.LUNCH } ).primary
		}
	}),
	[ bookingConstants.TRANSPORT ]: StyleSheet.create({
		listItem: {
			borderLeftWidth: 5,
			borderLeftColor: ObjectBooking.getColor( { kind: bookingConstants.TRANSPORT } ).primary
		}
	})
}

export default BookingsListItem
